<template>
  <div class="wrapper-detail">
    <div class="wrapper-item">
      <div class="para-title">订单信息</div>

      <!-- 订单信息 -->
      <OrderInfo
          :detailInfo="detailInfo"
          :flag.sync="flag"
          @updateDetail="getReviewOrderDetail"
      />

      <!-- 账单信息 -->
      <template v-if="!!detailInfo.store">
        <PeriodStoreInfo
            ref="period"
            @resetBill="resetBill"
            :detailInfo="detailInfo"
        />
      </template>
      <template v-else>
        <PeriodMallInfo
            ref="period"
            :billPeriodNum="detailInfo.billPeriodNum"
            :eachRentPrice="detailInfo.eachRentPrice"
        />
      </template>

      <!-- 收货信息 -->
      <AddressInfo
          :flag.sync="flag"
          :orderAddress="detailInfo.orderAddress"
          @updateDetail="getReviewOrderDetail"
      />
    </div>

    <!-- 门店信息 -->
    <div class="wrapper-item mt20">
      <div class="para-title">门店信息</div>
      <template v-if="!!detailInfo.store">
        <StoreInfo
            :detailInfo="detailInfo"
            :flag.sync="flag"
            @updateDetail="getReviewOrderDetail"
        />
      </template>
    </div>

    <div class="wrapper-item mt20">
      <div class="para-title">其他</div>

      <!-- 紧急联系人 -->
      <ContactInfo
          :type="1"
          :flag.sync="flag"
          :member="detailInfo.member"
          :orderInfo="detailInfo"
          @updateDetail="getReviewOrderDetail"
      />

      <!-- 订单备注 -->
      <ContactInfo
          :type="2"
          :flag.sync="flag"
          :member="detailInfo.member"
          :orderInfo="detailInfo"
          @updateDetail="getReviewOrderDetail"
          style="margin-top: 10px;"
      />
    </div>
  </div>
</template>

<script>
import { getReviewOrderDetailAPI } from "./api";
import OrderInfo from "./modules/order-info.vue";
import StoreInfo from "./modules/store-info.vue";
import ContactInfo from "./modules/contact-info.vue";
import AddressInfo from "./modules/address-info.vue";
import PeriodStoreInfo from "./modules/period-store-info.vue";
import PeriodMallInfo from "./modules/period-mall-info.vue";

export default {
  name: "DetailBase",

  components: {
    OrderInfo,
    StoreInfo,
    ContactInfo,
    AddressInfo,
    PeriodStoreInfo,
    PeriodMallInfo,
  },

  data() {
    return {
      detailInfo: {},
      flag: true,
    };
  },

  computed: {
    finalLevel() {
      return this.detailInfo.orderScoreProfile
        ? this.detailInfo.orderScoreProfile.finalHitGrade
        : "";
    },

    sysScore() {
      return this.detailInfo.orderScoreProfile
        ? this.detailInfo.orderScoreProfile.sysHitScore
        : "";
    },

    sysLevel() {
      return this.detailInfo.orderScoreProfile
        ? this.detailInfo.orderScoreProfile.sysHitGrade
        : "";
    },

    scoreProfileData() {
      return this.detailInfo.orderScoreProfile || {};
    },
  },

  created() {
    // 可以更新账期
    localStorage.setItem("is_update_period", "true");
  },

  mounted() {
    // 窗口关闭清除本地缓存
    let that = this;
    window.onbeforeunload = () => {
      localStorage.removeItem("updateBill:" + that.detailInfo.orderNo);
      localStorage.removeItem("storeBillIndex:" + that.detailInfo.orderNo);
      localStorage.removeItem("storeBill:" + that.detailInfo.orderNo);
    };
  },

  activated() {
    this.getReviewOrderDetail();
  },

  deactivated() {
    // 页面失活清除本地缓存
    localStorage.removeItem("updateBill:" + this.detailInfo.orderNo);
    localStorage.removeItem("storeBillIndex:" + this.detailInfo.orderNo);
    localStorage.removeItem("storeBill:" + this.detailInfo.orderNo);
  },

  methods: {
    goJiShen() {
      this.$emit("goJS");
    },

    async getReviewOrderDetail() {
      this.detailInfo = await getReviewOrderDetailAPI(this.$route.params.id);
      if (localStorage.getItem("is_update_period") == "true") {
        if (this.detailInfo.storeBillOptionList) {
          let storeBillOption = JSON.stringify(
            this.detailInfo.storeBillOptionList,
          );
          localStorage.setItem(
            "storeBill:" + this.detailInfo.orderNo,
            storeBillOption,
          );
          localStorage.setItem(
            "updateBill:" + this.detailInfo.orderNo,
            storeBillOption,
          );
          this.$store.commit(
            "UPDATE_PERIOD",
            this.detailInfo.storeBillOptionList[
              localStorage.getItem(
                "storeBillIndex:" + this.detailInfo.orderNo,
              ) - 0
            ].prepayBill,
          );
        } else {
          this.$refs.period.periodList = this.detailInfo.prepayPeriodList;
          this.$store.commit("UPDATE_PERIOD", this.detailInfo.prepayPeriodList);
        }
      } else {
        if (this.detailInfo.storeBillOptionList) {
          Object.assign(
            this.detailInfo.storeBillOptionList,
            JSON.parse(
              localStorage.getItem("updateBill:" + this.detailInfo.orderNo),
            ),
          );
        }
      }
      // 设置账期不会随其他设置而改变
      localStorage.setItem("is_update_period", "false");
      this.$emit("updateDetail", this.detailInfo);
    },

    resetBill({ bill, index }) {
      // 修改当前账单
      Object.assign(this.detailInfo.storeBillOptionList[index], bill);
      // 备份当前修改后的账单
      localStorage.setItem(
        "updateBill:" + this.detailInfo.orderNo,
        JSON.stringify(this.detailInfo.storeBillOptionList),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-detail {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll !important;

  .wrapper-item {
    background-color: #ffffff !important;
    border: none;
    width: 100%;
    border-radius: 12px;
    color: #222222;
    padding: 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

    .para-title {
      font-size: 18px;
      font-weight: 600;
      padding: 20px 24px;
      margin: 0;
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      border-bottom: 1px solid #e4e7ed;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: linear-gradient(180deg, #409EFF 0%, #66b1ff 100%);
      }
    }
  }
}

.without-layout .wrapper-detail {
  padding: 0 !important;
}

.mt20 {
  margin-top: 20px;
}
</style>
